// React
import { ReactElement } from 'react';
// Types
import { IconsEnum } from '@utmb/types/icons';
import { SliceQuotesSliderView, SliceQuoteView } from '@utmb/types/index';
// Styles
import styles from './single-race-slider.module.scss';
// Design System
import { Image } from '@utmb/design-system/image/Image';
import { Col } from '@utmb/design-system/box/Box';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Spacer } from '@utmb/design-system/spacer/Spacer';
import { Slides, SlidesItem } from '@utmb/design-system/slides/Slides';
import { NextButton, PrevButton } from '@utmb/design-system/slides/buttons';
// Utils
import { v4 as uuidv4 } from 'uuid';

const SingleRaceSlider = (props: SliceQuotesSliderView): ReactElement | null => {
    const { quotes } = props;

    if (!quotes || !quotes.length) {
        return null;
    }

    return (
        <Slides
            className={styles.slider}
            carouselOptions={{
                containScroll: 'trimSnaps',
                align: 'start',
                draggable: true,
                loop: false,
            }}
        >
            {({ embla, currentSlide }) => (
                <>
                    {quotes.map((quote: SliceQuoteView, idx: number) => (
                        <SlidesItem key={uuidv4()} className={styles.item}>
                            <div className={styles.pic}>
                                <Image className={currentSlide + 1 === idx ? styles.dimmed : undefined} layout="fill" objectFit="cover" image={quote.picture} />
                                {embla?.canScrollPrev() && isActive(currentSlide, idx) && (
                                    <PrevButton onPress={() => embla?.scrollPrev()} className={styles.prev} />
                                )}
                                {embla?.canScrollNext() && isActive(currentSlide + 1, idx) && (
                                    <NextButton onPress={() => embla?.scrollNext()} className={styles.next} />
                                )}
                                {embla?.canScrollNext() && (
                                    <NextButton onPress={() => embla?.scrollNext()} className={[styles.next, styles.nextActionLG].join(' ')} />
                                )}
                            </div>
                            <Col className={styles.card}>
                                <Font.FuturaLight mobile="14" desktop="16" className={styles.card_content} as="div">
                                    <div className={styles.quote}>
                                        <Icon variant={IconsEnum.QUOTE} />
                                    </div>
                                    {quote.content}
                                </Font.FuturaLight>
                                <Font.FuturaBook mobile="14" desktop="20" className={styles.card_user_name}>
                                    {quote.author}
                                </Font.FuturaBook>
                                <Font.FuturaBook mobile="13" desktop="18" className={styles.card_race_name}>
                                    {quote.authorTitle}
                                </Font.FuturaBook>
                                <Spacer />
                            </Col>
                        </SlidesItem>
                    ))}
                </>
            )}
        </Slides>
    );
};

export default SingleRaceSlider;

// Utils
const isActive = (current: number, priority: number): boolean => current === priority;
